export const lazyComponents = {
  schedule: () => import(/* webpackChunkName: "schedule" */ '@/views/Schedule'),
  scheduleStart: () => import(/* webpackChunkName: "schedule" */ '@/views/Schedule.vue'),
  scheduleAuto: () => import(/* webpackChunkName: "schedule" */ '@/views/ScheduleAuto.vue'),
  reschedule: () => import(/* webpackChunkName: "reschedule" */ '@/views/ReSchedule.vue'),
  scheduledStart: () => import(/* webpackChunkName: "scheduled-start" */ '@/views/Scheduled.vue'),
  consultationHistory: () =>
    import(/* webpackChunkName: "consultation-history" */ '@/views/ConsultationHistory.vue'),
  overbookQueue: () => import(/* webpackChunkName: "overbook-queue" */ '@/views/OverbookQueue.vue'),
  callTest: () => import(/* webpackChunkName: "scheduled-test" */ '@/views/CallTest.vue'),
  callTestOverbook: () =>
    import(/* webpackChunkName: "scheduled-test-overbook" */ '@/views/CallTestOverbook.vue'),
  sortingMeet: () => import(/* webpackChunkName: "dashboard" */ '@/views/SortingMeet.vue'),
  thankYou: () => import(/* webpackChunkName: "thank-you" */ '@/views/ThankYou.vue'),
  notFound: () => import(/* webpackChunkName: "error" */ '@/views/NotFound.vue'),
  plansLogin: () => import(/* webpackChunkName: "plans-login" */ '@/views/tmed-plans/Login.vue'),
  plansRecover: () => import(/* webpackChunkName: "plans-recover" */ '@/views/tmed-plans/RecoverPassword.vue'),
  plansRegister: () => import(/* webpackChunkName: "plans-register" */ '@/views/tmed-plans/RegisterClient.vue'),
  plansBackofficeHome: () =>
    import(/* webpackChunkName: "plans-backoffice-home" */ '@/views/tmed-plans/backoffice/Home.vue'),
  plansEditProfile: () =>
    import(/* webpackChunkName: "plans-backoffice-edit-profile" */ '@/views/tmed-plans/backoffice/EditProfile.vue'),
  plansScheduleHistory: () =>
    import(/* webpackChunkName: "plans-schedules-history" */ '@/views/tmed-plans/backoffice/ScheduleHistory.vue'),
  plansMyPlan: () =>
    import(/* webpackChunkName: "plans-backoffice-plan" */ '@/views/tmed-plans/backoffice/MyPlan.vue'),
  plansPaymentHistory: () =>
    import(/* webpackChunkName: "plans-backoffice-payments" */ '@/views/tmed-plans/backoffice/PaymentHistory.vue'),
};
